module.exports = __webpack_public_path__ + "img/5.ba3dc544.png";